import clsx from 'clsx'

import { shouldShowFieldValue } from 'entities/kyrgyzstan/lib'

import { DynamicFieldValue } from 'shared/api/kyrgyzstan/search/model'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { ImageOptimized } from 'shared/ui/image-optimized'
import { Paper } from 'shared/ui/paper'

import s from './styles.module.scss'

interface AmenitiesListProps {
  dynamicFields: DynamicFieldValue
}

export const AmenitiesList = ({ dynamicFields }: AmenitiesListProps) => {
  if (!dynamicFields.items || dynamicFields.items.length === 0) {
    return null
  }

  return (
    <div className={s.container}>
      {dynamicFields.items.map((category) => {
        if (!category.fields || category.fields.length === 0) {
          return null
        }

        return (
          <Paper
            key={category.id}
            padding={[16, 16]}
            radius="16"
            className={s.categoryPaper}
          >
            <div className={s.categoryHeader}>
              {category.icon && (
                <ImageOptimized
                  src={category.icon}
                  alt={category.name}
                  width={28}
                  height={28}
                />
              )}

              <h2 className={clsx('bold-16', s.categoryTitle)}>
                {category.name}
              </h2>
            </div>

            <div className={s.amenitiesList}>
              {category.fields.map((field) => (
                <div
                  key={field.id}
                  className={s.amenityItem}
                >
                  <AppIcon
                    id={AllIcons.CHECK_MARK}
                    width={20}
                    height={20}
                    className={s.amenityIcon}
                  />
                  <span className={clsx('semi-bold-14', s.amenityLabel)}>
                    {field.name}
                    {shouldShowFieldValue(field) && (
                      <span className={s.amenityValue}>
                        {': '}
                        {field.value}
                      </span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          </Paper>
        )
      })}
    </div>
  )
}
